import { HttpResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { CMSSettingsAuthService } from '../cms/settings/auth/cms-auth.service';
import { CMSSettingsContentService } from '../cms/settings/content/cms-content.service';

export interface Token {
  access_token: string;
  expires_in: number;
  scope: string;
  token_type: string;
}

@Component({
  selector: 'fcp-google-analytics',
  templateUrl: './google-analytics.component.html',
  styleUrls: ['./google-analytics.component.css']
})
export class GoogleAnalyticsComponent {

  constructor(
    private cmsSettingsAuthService: CMSSettingsAuthService,
    private cmsSettingsContentService: CMSSettingsContentService
  ) {
    this.getContent();
    return;
    let token = this.cmsSettingsAuthService.getToken();
    if (!token) {
      this.cmsSettingsAuthService.auth().subscribe((newToken: HttpResponse<any>) => {
        token = newToken.body.token_type + ' ' + newToken.body.access_token;
        this.cmsSettingsAuthService.setToken(token);
        this.getContent();
      });
    } else {
      this.getContent();
    }
  }

  getContent() {
    const id = 'G-7BBRN4V3V9'; // 'G-JDC4EWPP53';
    (<any>window).ga('create', `${id}`, 'auto');

    /*this.cmsSettingsContentService.return('configuracao-site').subscribe(response => {
      const id = response.items[0].data.GoogleAnalytics.iv;
      (<any>window).ga('create', `${id}`, 'auto');
    });*/
  }

}
